module.exports = __webpack_public_path__ + "components/forecast-table/static/weather-forecast_sunrise-2ff787eab7c9a95085a937a952337df0.svg";